export const getEditPostUrl = (postId: string) => {
  return `/posts/edit/${postId}`;
};
export const getCreatePostUrl = () => {
  return `/posts/create`;
};
export const getQRCodeUrl = (qrCodeId: string) => {
  return `/matterport/qr-code/${qrCodeId}`;
}
export const getPOIUrl = (poiId: string) => {
  return `/matterport/poi/${poiId}`;
}
export const getLocationBookmarkUrl = (bookmarkId: string) => {
  return `/earthtwin2/bookmark/${bookmarkId}`;
};
